import React from 'react';
import { useTranslation } from 'react-i18next';
import { getField } from 'src/utils/EntryUtil';
import { testAttribute } from '../../utils/Serenity';
import { applyEntryDataAttributes } from '../EntryWrapper/EntryDataWrapper';
import { useProductPricing } from '../ProductPricing/ProductPricing';
import { useSalesChannel } from '../SalesChannel/SalesChannel';
import { IProductPrice } from './IProductPrice';
import { MsrpPrice } from './MsrpPrice';
import styles from './ProductPrice.scss';

const ProductPrice: React.FC<IProductPrice> = ({ entry, translationKey = 'product-price', ...props }) => {
  const dcsId = getField(entry, 'dcsId');
  const { t } = useTranslation();
  const { salesChannel } = useSalesChannel();
  const { productPricings } = useProductPricing();

  if (!dcsId || !productPricings) return null;

  const productPricing = productPricings.find(product => product?.id === dcsId);

  if (!productPricing) return null;

  const price = productPricing?.basePrice.value;
  const msrp = productPricing?.msrp?.value;

  if (!price || !msrp) return null;

  const showMsrp = getField(salesChannel, 'showMsrp');
  const dataTest = testAttribute(getField(entry, 'title'))?.concat('msrp');

  return (
      <div {...props} className={styles.productPrice}>
        <span>{t(translationKey as any, { price })}</span>
        <MsrpPrice data-test={dataTest} price={price} msrp={msrp} showMsrp={showMsrp} />
      </div>
  );
};

const Wrapped = applyEntryDataAttributes(ProductPrice);
type Wrapped = typeof Wrapped;

export { Wrapped as ProductPrice };
